const input = {
  // 1. We can update the base styles
  // baseStyle: {
  // },
  // 2. We can add a new button size or extend existing
  // sizes: {
  // xl: {
  //     h: '56px',
  //     fontSize: 'lg',
  //     px: '32px',
  // },
  // },
  // 3. We can add a new visual variant
  variants: {
    flushed: () => ({
      bg: 'blue',
      borderRadius: '0',
      _focus: {
        borderColor: 'blue',
      },
    }),
  },
};

export default input;
